import { render, staticRenderFns } from "./FreeResource.vue?vue&type=template&id=23c59054&scoped=true"
import script from "./FreeResource.vue?vue&type=script&lang=js"
export * from "./FreeResource.vue?vue&type=script&lang=js"
import style0 from "./FreeResource.vue?vue&type=style&index=0&id=23c59054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c59054",
  null
  
)

export default component.exports